export default [{
	type: "Cloth",
	classes: [8, 5, 9]
}, {
	type: "Leather",
	classes: [4, 11, 10, 12]
}, {
	type: "Mail",
	classes: [7, 3, 13]
}, {
	type: "Plate",
	classes: [1, 2, 6]
}];